import { API_CONFIG } from '../config/api';

export interface SignupData {
  username: string;
  password: string;
  email: string;
  role: string;
}

export interface LoginData {
  username: string;
  password: string;
}

export interface AuthResponse {
  status: 'success' | 'error';
  message?: string;
  results?: any[];
}

class AuthService {
  private baseUrl = API_CONFIG.AUTH.BASE_URL;
  private model = API_CONFIG.AUTH.MODEL;

  async signup(userData: SignupData): Promise<AuthResponse> {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'signup',
          model: this.model,
          data: userData
        })
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Signup error:', error);
      return {
        status: 'error',
        message: 'An error occurred during registration. Please try again.'
      };
    }
  }

  async login(loginData: LoginData): Promise<AuthResponse> {
    try {
      const criteria = {
        "username": { "equal": loginData.username },
        "password": { "equal": loginData.password }
      };

      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'login',
          model: this.model,
          criteria: criteria,
          driver: 'sqlite'
        })
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Login error:', error);
      return {
        status: 'error',
        message: 'An error occurred. Please try again.'
      };
    }
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
    // Scrivi anche nel cookie (accessibile lato server/PHP)
    const maxAge = 60 * 60 * 24 * 30; // 30 giorni in secondi
    document.cookie = `token=${encodeURIComponent(token)}; max-age=${maxAge}; path=/; domain=.escortfun.net; SameSite=Lax`;
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  removeToken(): void {
    localStorage.removeItem('token');
    // Rimuovi anche il cookie
    document.cookie = 'token=; max-age=0; path=/; domain=.escortfun.net; SameSite=Lax';
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  logout(): void {
    this.removeToken();
  }
}

export const authService = new AuthService();
